<template>
  <div>
    <div class="row" style="margin-top: 1%;">
      <!--<div class="col-md-3">-->
      <!-- Info Boxes Style 2 -->
      <!--<div class="info-box mb-3 bg-warning">
        <span class="info-box-icon"><i class="fas fa-plus"></i></span>

        <div class="info-box-content">
          <span class="info-box-text">Prospectus Issuance</span>-->
      <!--<span class="info-box-number">5,200</span>-->
      <!--</div>-->
      <!-- /.info-box-content -->
      <!--</div>-->
      <!-- /.info-box -->
      <!--</div>-->
      <div class="col-md-3">
        <a href="/Admission/AdmissionForm" class="info-box mb-3 bg-success">
          <span class="info-box-icon"><i class="fa fa-user-plus"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">New  Prospect Student</span>
            <!--<span class="info-box-number">92,050</span>-->
          </div>
          <!-- /.info-box-content -->
        </a>
        <!-- /.info-box -->
      </div>
      <div class="col-md-3">
        <a href="/Admission/ProspectStudents" class="info-box mb-3 bg-danger">
          <span class="info-box-icon"><i class="fas fa-list"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Document Verification</span>
            <!--<span class="info-box-number">114,381</span>-->
          </div>
          <!-- /.info-box-content -->
        </a>
        <!-- /.info-box -->
      </div>
      <div class="col-md-3">
        <a href="/Admission/ProspectStudents" class="info-box mb-3 bg-info">
          <span class="info-box-icon"><i class="fas fa-dollar-sign"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Payment Verification</span>
            <!--<span class="info-box-number">163,921</span>-->
          </div>
          <!-- /.info-box-content -->
        </a>
        <!-- /.info-box -->
      </div>
    </div>

    <div class="row" style="margin-top: 20px">
      <div class="col-md-3">
        <div class="row">
          <div class="col-lg-12 col-xs-12">
            <!-- small box -->
            <div class="small-box bg-red">
              <div class="inner">
                <h3>{{total}}</h3>
                <p>Total Applications</p>
              </div>
              <div class="icon">
                <i class="fa fa-users"></i>
              </div>
              <a href="../Admission/ProspectStudents" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>
            </div>
          </div>

          <div class="col-lg-12 col-xs-12">
            <!-- small box -->
            <div class="small-box bg-blue">
              <div class="inner">
                <h3>{{sub}}</h3>

                <p>Submitted Applications</p>
              </div>
              <div class="icon">
                <i class="fa fa-file"></i>
              </div>
              <a href="../Admission/ProspectStudents" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>
            </div>
          </div>

          <div class="col-lg-12 col-xs-12">
            <!-- small box -->
            <div class="small-box bg-aqua">
              <div class="inner">
                <h3>{{unsub}}</h3>

                <p>Payment Verfied Applications</p>
              </div>
              <div class="icon">
                <i class="fas fa-dollar-sign"></i>
              </div>
              <a href="../Admission/ProspectStudents" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-9">
        <div class="card card-info">
          <div class="card-header">Program Wise Applications Status</div>
          <div class="card-body">
            <div style="height:400px" id="chartdiv"></div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>

      <div class="col-md-12" id="printBarChatDiv">
        <div class="card card-info">
          <div class="card-header">
            Total Applications Vs Submited Applications
            <button class="btn btn-info float-right" v-on:click="printdiv()">Print</button>
          </div>
          <div class="card-body">
            <div style="height:400px" id="Barchartdiv"></div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card card-info">
          <div class="card-header">Admission Revenue</div>
          <div class="card-body">
            <div style="height:400px" id="Barchartdiv2"></div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
      <div class="col-md-12" id="printlineChatDiv">
        <div class="card card-info">
          <div class="card-header">
            Total Fee Deposite Revenue
            <button class="btn btn-info float-right" v-on:click="printlinediv()">Print</button>
          </div>
          <div class="card-body">
            <div style="height:400px" id="RevenuePieCharts"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        forms: [],
        stundents: [],
        sub: 0,
        unsub: 0,
        total: 0,
        colorInd: 0,
        data: [],
        totsub: [],
        Revenue: [],
        AdmissionRevenue:[]
      }
    },

    created: function () {
      //this.loadAccess();
      this.loadAdmissionData();
    },

    methods: {
      loadAccess() {
        startReq();
        var vm = this;
        axios.post('/admissionapi.asmx/loadDashborad')
          .then(function (p) {
            vm.forms = p.data;
            endReq();
          })
      },
      loadAdmissionData() {
        startReq();
        var vm = this;
        axios.post('/api/AdmissionApi/loadAdmissionData')
          .then(function (p) {
            vm.stundents = p.data.progwisestd;
            vm.sub = p.data.sub;
            vm.Revenue = p.data.FeeRevenue;
            vm.total = p.data.tot;
            vm.unsub = p.data.Unsub;
            vm.totsub = p.data.totapp;
            vm.AdmissionRevenue = p.data.AdmissionRevenue;
            endReq();
            vm.loadChart();
            vm.loadBarchart();
            vm.loadBarchart2();
            vm.loadRevenueChart();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      printdiv() {
        $("#printBarChatDiv").print();
      },

      printlinediv() {
        $("#printlineChatDiv").print();
      },

      loadcolor(ind) {
        return "background-color:" + this.Backgroundcolor[ind];
      },

      loadChart() {
        am4core.addLicense("ch-custom-attribution");
        am4core.useTheme(am4themes_animated);
        var chart = am4core.create("chartdiv", am4charts.PieChart3D);
        chart.data = this.stundents;
        var series = chart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "Count";
        series.dataFields.category = "ShortName";
        series.ticks.template.disabled = true;
        series.labels.template.disabled = true;
        series.innerRadius = am4core.percent(50);
        chart.legend = new am4charts.Legend();
        chart.legend.position = "right";
        chart.legend.scrollable = true;
        chart.legend.width = "10%";
      },

      loadBarchart() {
        //var n = [];
        //var labels = [];
        //var n2 = [];


        //for (var i = 0; i < this.stundents.length; i++) {
        //  n.push(this.stundents[i].ProgramName);
        //  n.push(this.stundents[i].Count);
        //}

        //for (var i = 0; i < this.totsub.length; i++) {
        //  n2.push(this.totsub[v].Count);
        //}

        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        var chart = am4core.create("Barchartdiv", am4charts.XYChart3D);

        // Add data
        chart.data = this.totsub;

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "ShortName";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = 270;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.labels.template.adapter.add("text", function (text) {
          return text;
        });

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = "TotAppCount";
        series.dataFields.categoryX = "ShortName";
        series.name = "Total Applications";
        series.clustered = false;
        series.columns.template.tooltipText = "Total Submited Applications in {ShortName} : [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.9;

        var series2 = chart.series.push(new am4charts.ColumnSeries3D());
        series2.dataFields.valueY = "TotCount";
        series2.dataFields.categoryX = "ShortName";
        series2.name = "Total Submited Applications";
        series2.clustered = false;
        series2.columns.template.tooltipText = "Total Applications in {ShortName} : [bold]{valueY}[/]";


      },

      loadRevenueChart() {

        am4core.addLicense("ch-custom-attribution");
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        var chart = am4core.create("RevenuePieCharts", am4charts.PieChart);

        // Add data
        chart.data = this.Revenue;

        // Set inner radius
        var series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "totalAmountPaid";
        series.dataFields.category = "ShortName";
        series.ticks.template.disabled = true;
        series.labels.template.disabled = true;
        series.innerRadius = am4core.percent(50);
        chart.legend = new am4charts.Legend();
        chart.legend.position = "right";
        chart.legend.scrollable = true;
        chart.legend.width = "10%";

      },
        loadBarchart2() {

        am4core.addLicense("ch-custom-attribution");
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        var chart = am4core.create("Barchartdiv2", am4charts.XYChart3D);
        // Add data
          chart.data = this.AdmissionRevenue;

        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "ShortName";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = 270;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.labels.template.adapter.add("text", function (text) {
          return text;
        });

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = "Amount";
        series.dataFields.categoryX = "ShortName";
        series.name = "Total Applications";
        series.clustered = false;
        series.columns.template.tooltipText = "Total Revenue in {ShortName} : [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.9;
          chart.scrollbarY = new am4core.Scrollbar();
          chart.scrollbarY.parent = chart.leftAxesContainer;
          chart.scrollbarX = new am4core.Scrollbar();
          chart.scrollbarX.parent = chart.leftAxesContainer;

      },
    }
  })
</script>
<style>
  #linechartdiv {
    width: 100%;
    height: 500px;
  }
</style>




// WEBPACK FOOTER //
// src/components/onlineadmission/OnlineAdmissionDashboard.vue